import React, { useState, useEffect } from 'react';
import { Coins, Calendar, Activity } from 'lucide-react';
import UserStatsCard from '../admin/UserStatsCard';
import UsageTable from '../admin/UsageTable';
import { TokenUsageTrend } from '../admin/UsageCharts';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import api from '../../services/api';

const UserDashboard = () => {
    const [userData, setUserData] = useState({
      coins: 0,
      usage: [],
      subscription: {
        status: '',
        endDate: ''
      }
    });
  
    useEffect(() => {
      // Fetch user dashboard data
      const fetchData = async () => {
        try {
          const response = await api.get('/users/usage');
          setUserData(response.data.data);
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      };
      fetchData();
    }, []);
  
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl font-bold mb-2">Usage Dashboard</h1>
          <p className="text-gray-600">Monitor your token usage and subscription</p>
        </div>
  
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <UserStatsCard 
            title="Available Coins" 
            value={userData.coins.toLocaleString()} 
            icon={Coins}
          />
          <UserStatsCard 
            title="Subscription Status" 
            value={userData.subscription.status} 
            icon={Calendar}
          />
          <UserStatsCard 
            title="Total Usage" 
            value={`${(userData.usage.length / 1000).toFixed(1)}k`} 
            icon={Activity}
          />
        </div>
  
        {/* Usage Chart */}
        <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
          <h3 className="text-lg font-semibold mb-4">Usage History</h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={userData.usage}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="timestamp" tickFormatter={timestamp => new Date(timestamp).toLocaleDateString()} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="tokens" stroke="#f97316" name="Tokens Used" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
  
        {/* Usage Table */}
        <UsageTable 
          data={userData.usage.map(usage => ({
            operationType: usage.operationType,
            tokens: usage.tokens,
            cost: usage.cost,
            timestamp: usage.timestamp
          }))}
        />
      </div>
    );
  };

export default UserDashboard;